import { render, staticRenderFns } from "./ColonPrintBowelCleanseForms.vue?vue&type=template&id=244fb3e0"
import script from "./ColonPrintBowelCleanseForms.vue?vue&type=script&lang=js"
export * from "./ColonPrintBowelCleanseForms.vue?vue&type=script&lang=js"
import style0 from "./ColonPrintBowelCleanseForms.vue?vue&type=style&index=0&id=244fb3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports